module.exports = __webpack_public_path__ + "static/KB_img-f24269e1c7865d33665f73af811d4371.png";